export const ROUTE_HOME = 'home';
export const ROUTE_LOGOUT_SUCCESS = '#logout=success';
export const ROUTE_CUSTOMER_REGISTRATION = 'kunden-registrierung';
export const ROUTE_COMPANY_SELECT = 'unternehmen-auswahl';
export const ROUTE_COMPANY_CHECK = 'unternehmen-pruefung';
export const ROUTE_AGENT_SELECTION = 'berater-auswahl';
export const ROUTE_INVITE = 'einladen';
export const ROUTE_THANK_YOU = 'danke';
export const ROUTE_RESEND_INVITATION_POPUP = 'erneut-einladen';

export const ROUTE_KUNDENACCOUNT_ANPASSEN = 'kundenaccount-anpassen';
export const ROUTE_GP_AUSWAHL = 'gp-auswahl';
export const ROUTE_DATEN_PRUEFEN = 'daten-pruefen';
export const ROUTE_BETREUERKONTAKT = 'betreuerkontakt';
export const ROUTE_BESTAETIGUNG = 'bestaetigung';

// Pagination
export const PAGE_SIZE = 10;

// API
export const API_ROUTE_UNTERNEHMEN = 'unternehmen';
export const API_ROUTE_ACCOUNT_BY_GPNR = (gpNr: string) => `${API_ROUTE_UNTERNEHMEN}/${gpNr}/account`;
export const API_ROUTE_SEARCH_UNTERNEHMEN = `${API_ROUTE_UNTERNEHMEN}/search`;
export const API_ROUTE_SEARCH_ACCOUNTS = `${API_ROUTE_UNTERNEHMEN}/accounts/search`;
export const API_ROUTE_SEARCH_BERATER = 'kundenberater/search';
export const API_ROUTE_FEATURE_FLAGS = 'feature-flags';
export const API_ROUTE_GET_BERATER = 'kundenberater';
export const API_ROUTE_CREATE_CUSTOMER = 'account/register';
export const API_ROUTE_MODIFY_ACCOUNT = (accountId: string) => `account/${accountId}`;
export const API_ROUTE_EMAIL_EXISTANCE_CHECK = 'account/email/exists';

export function getApiUrl(apiUrl: string, route: string) {
  return `${apiUrl}/v1/ikp/berater/${route}`;
}

export function getFeatureFlagApiUrl(apiUrl: string, route: string) {
  return `${apiUrl}/v1/ikp/auth/${route}`;
}

export function getCustomerRegistrationUrl(route: string) {
  return `${ROUTE_CUSTOMER_REGISTRATION}/${route}`;
}
